<template>
    <div v-else>
        <!-- responsive-header -->
        <responsive-header-component></responsive-header-component>
        <!-- responsive-header -->

        <div class="wrapper default">

            <!-- header -->
            <header class="main-header default">
                <div class="container">
                    <header-component></header-component>
                </div>
                <navbar-component></navbar-component>
            </header>
            <main class="cart default">
                <div class="container text-center">
                    <div class="cart-empty">
                        <div class="cart-empty-icon">
                            <i style="color:#85c480" class="now-ui-icons media-2_sound-wave"></i>
                        </div>
                        <div class="cart-empty-title">
                            درخواست شما با موفقیت انجام شد.
                        </div>


                    </div>
                </div>
            </main>

            <footer-component></footer-component>
            <footer-fixnav-component></footer-fixnav-component>
        </div>

    </div>

</template>

<script>

    export default {
        data() {
            return {
                showLoader: false
            }
        },
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        }, 
        beforeMount() {
            
        }
    }
</script>

<style scoped>
    .cart-empty-title {
        font-size: 23px;
        margin: 50px 0 60px;
        color: #858585;
    }
</style>